<div mat-dialog-content class="dialog-content text-center">
  <div class="icon-wrapper">
    <mat-icon class="delete-icon">delete</mat-icon>
  </div>

  <h2 class="dialog-title pt-3 font-name">{{ data.title || 'Delete' }}</h2>
  <p class="dialog-message pt-1 font-name">
    {{ data.message || 'Are you sure you want to delete this item?' }}
  </p>

  <div mat-dialog-actions align="center" class="dialog-actions">
    <button class="btn btn-color font-name" (click)="closeDialog(false)">
      {{ data.cancelText || 'Cancel' }}
    </button>
    <button class="btn btn-danger ms-3 font-name" (click)="closeDialog(true)">
      {{ data.confirmText || 'Confirm' }}
    </button>
  </div>
</div>
